import ConsentType from '@/constants/consentTypeEnum';

/**
 * Retrieve Privacy Policy flagged Policy from Consent list
 * @param {VuexState} state
 * @returns {Policy}
 * @TODO harden consumer `hg-opt-out` to be more resilient to `undefined` output
 */
const getPrivacyPolicy = state => {
  const { policies } = state.consents;
  return policies.find(consent => consent.subType === ConsentType.PRIVACY_POLICY)
    || {};
};

/**
 * Retrieve Terms of Use flagged Policy from Consent list
 * @param {VuexState} state
 * @returns {Policy}
 * @TODO harden consumer `hg-opt-out` to be more resilient to `undefined` output
 */
const getTermsOfUse = state => {
  const { policies } = state.consents;
  return policies.find(consent => consent.subType === ConsentType.TERMS_OF_USE)
    || {};
};

export default {
  getPrivacyPolicy,
  getTermsOfUse,
};
